var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemconnectedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "System_connected_icon",
    "data-name": "System connected icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 169.55,
    height: 130.336,
    viewBox: "0 0 169.55 130.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4708",
    "data-name": "Rectangle 4708",
    width: 78.771,
    height: 45.716,
    transform: "translate(-8984.994 -18526.244) rotate(135)",
    fill: "#56aa1c",
    opacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4710",
    "data-name": "Rectangle 4710",
    width: 40.47,
    height: 20.861,
    transform: "translate(-9078.979 -18509.859) rotate(45)",
    fill: "#56aa1c",
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System_connected_icon-2",
    "data-name": "System connected icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36967",
    "data-name": "Path 36967",
    d: "M-172.63,371.871V490.278h71.665V371.871Zm29.786,87.956h-16v-16h16Zm0-27.553h-16v-16h16Zm0-27.552h-16v-16h16Zm27.66,55.105h-16v-16h16Zm0-27.553h-16v-16h16Zm0-27.552h-16v-16h16Zm75.641,22.931V490.7h-16.7v-33.25H-81.186V490.7h-16.7V427.652Zm0-11.609H-97.891v8.783h58.348Z",
    transform: "translate(172.63 -371.871)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_73",
    "data-name": "Mask Group 73",
    transform: "translate(9154.544 18596.828)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4707",
    "data-name": "Rectangle 4707",
    width: 76.771,
    height: 17,
    transform: "translate(-8996.561 -18534.982) rotate(135)",
    fill: "#56aa1c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_74",
    "data-name": "Mask Group 74",
    transform: "translate(9154.544 18596.828)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4709",
    "data-name": "Rectangle 4709",
    width: 40.47,
    height: 17,
    transform: "translate(-9078.979 -18509.859) rotate(45)",
    fill: "#56aa1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemconnectedicon);
export default __webpack_public_path__ + "static/media/System connected icon.f6920edfc89dc3a9fa76d9153fbfb734.svg";
export { ForwardRef as ReactComponent };